interface FormErrors {
  selectedTariff?: string;
  wifiUpgrade?: string;
  landline?: string;
  callPackage?: string;
  callPackageId?: string;
  includeVoip?: string;
}

enum PlanTypes {
  FTTP = 'Full Fibre',
  FTTC = 'Part Fibre',
  Copper = 'Copper',
}

interface BroadbandTileDiscount {
  duration: number;
  price: string;
  contractLength: number;
}

export { PlanTypes };
export type { FormErrors, BroadbandTileDiscount };
